<template>
  <!-- <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-dialog
      :show-error-alert-dialog="showErrorAlertDialog"
      :error="networkError" @dismissClicked="showErrorAlertDialog=false">
    </error-alert-dialog>
    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div v-if="showUI" class="margin_top_20">
      <div class="dropdown_container">
        <wxc-dropdown
          title="Profession" default-item="Select" :config="dropdownConfig"
          :list="professionOptions" @onItemSelected="onProfessionSelected"></wxc-dropdown>
      </div>

      <div class="input_container">
        <weex-text class="input_label">{{salaryLabel}}</weex-text>
        <weex-text class="input_label_des">{{salaryLabelDes}}</weex-text>
        <div class="item-price-input-container">
          <input
            :readonly="true"
            class="item-price-label-input"
            :value="rupeeSign" />
          <input
            class="item-price-input"
            :value="salary"
            @input="salary=$event.target.value"
            type="number" />
        </div>
      </div>
      <wxc-button
        text="Next"
        class="btnStyleNext"
        type="blue"
        @wxcButtonClicked="onSubmit"
      >
      </wxc-button>
    </div>

  </div> -->
    <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <data-table-stage-config-activity-provider></data-table-stage-config-activity-provider>
  </div>
</template>

<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import DataTableStageConfigActivityProvider
  from "@/components/providers/DataTableStageConfigActivityProvider";
import { Activities } from '../../../utils/ActivityNavigator';

export default {
  name: "ProfessionalDetailsActivity",
  components: {ActivityRedirectItem, DataTableStageConfigActivityProvider},

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PROFESSIONAL];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    }
  }
}

// import ToolBar from "../../layout/ToolBar";
// import Loading from "../../layout/Loading";
// import WxcButton from "@/../weex-ui/packages/wxc-button/index";
// import EzUtils from "../../../utils/EzUtils";
// import alertService from "@/components/core/alert/AlertService";
// import loanTasksUtility from "@/utils/LoanTasksUtility";
// import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
// import loanTasksActivityNavigator from "@/utils/LoanTasksActivityNavigator";
// import dataSource from "@/data/DataSource";
// import { DataTables } from "@/utils/DataTables";
// import PersonalDetails from "@/data/model/PersonalDetails";
// import professionalDetailsResponse from "@/data/model/ProfessionalDetailsResponse";
// import { Constants } from "@/components/Constants";
// import ErrorAlertDialog from "@/components/dialogs/ErrorAlertDialog";
// import { DefaultResourceConfig } from "@/utils/ImageResourcesUtil";
// import WxcDropdown from "@/../weex-ui/packages/wxc-dropdown/index"
// import { MessageConstants } from "../../../utils/MessageConstantUtil";
// import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
// import { Activities } from "@/utils/ActivityNavigator";
// import StageCommentItem from "../../layout/StageCommentItem";
// import storageUtil from "../../../utils/StorageUtil";

// export default {
//   name: "ProfessionalDetailsActivity",
//   components: {
//     ActivityRedirectItem,
//     ErrorAlertDialog,
//     ToolBar,
//     WxcButton,
//     Loading,
//     WxcDropdown,
//     StageCommentItem
//   },
//   data: () => ({
//     toolbarTitle: "Professional Details",
//     professionOptions: [],
//     profession: "",
//     salary: "",
//     showUI: false,
//     loading: false,
//     showErrorAlertDialog: false,
//     networkError: {}
//   }),

//   methods: {

//     onProfessionSelected(e) {
//       this.profession = e.value;
//     },

//     onSubmit() {
//       if (this.checkForValidation()) {
//         this.saveProfession()
//       }
//     },

//     checkForValidation() {
//       if (EzUtils.isEmpty(this.profession)) {
//         this.showToast(MessageConstants.SELECT_PROFESSION_MESSAGE);
//         return false;
//       }
//       if (EzUtils.isEmpty(this.salary) && "BUSINESS" === this.profession) {
//         this.showToast(MessageConstants.EMPTY_DECLARED_INCOME_MESSAGE);
//         return false;
//       }
//       if (EzUtils.isEmpty(this.salary) && "SALARIED" === this.profession) {
//         this.showToast(MessageConstants.EMPTY_SALARY_MESSAGE);
//         return false;
//       }
//       return true;
//     },

//     saveProfession() {
//       this.loading = true;
//       dataSource.getDataTableInfo(DataTables.PERSONAL_DETAILS, loanScopeDataHolder.getClientId())
//         .then(personalDetailsRes => {
//           if (personalDetailsRes.errorOccurred) {
//             this.loading = false;
//             this.networkError = personalDetailsRes.data;
//             this.showErrorAlertDialog = true;
//           } else {
//             const payload = PersonalDetails.getProfessionPayLoad(this.profession);
//             if (EzUtils.isEmpty(personalDetailsRes.data)) {
//               dataSource.addDataTableEntry(DataTables.PERSONAL_DETAILS,
//                 loanScopeDataHolder.getClientId(), payload)
//                 .then(personalDetailsSaveRes => {
//                   if (personalDetailsSaveRes.errorOccurred) {
//                     this.loading = false;
//                     this.networkError = personalDetailsSaveRes.data;
//                     this.showErrorAlertDialog = true;
//                   } else {
//                     this.saveSalary();
//                   }
//                 })
//             } else {
//               dataSource.updateDataTableEntry(DataTables.PERSONAL_DETAILS,
//                 loanScopeDataHolder.getClientId(), payload)
//                 .then(personalDetailsSaveRes => {
//                   if (personalDetailsSaveRes.errorOccurred) {
//                     this.loading = false;
//                     this.networkError = personalDetailsSaveRes.data;
//                     this.showErrorAlertDialog = true;
//                   } else {
//                     this.saveSalary();
//                   }
//                 })
//             }
//           }
//         })
//     },

//     showToast(message) {
//       alertService.showToast(message);
//     },

//     saveSalary() {
//       dataSource.getDataTableInfo(DataTables.PROFESSIONAL_DETAILS,
//         loanScopeDataHolder.getClientId())
//         .then(professionalDetailsRes => {
//           if (professionalDetailsRes.errorOccurred) {
//             this.loading = false;
//             this.networkError = professionalDetailsRes.data;
//             this.showErrorAlertDialog = true;
//           } else {
//             const payload = professionalDetailsResponse.getSalaryPayLoad(this.salary);
//             if (EzUtils.isEmpty(professionalDetailsRes.data)) {
//               dataSource.addDataTableEntry(DataTables.PROFESSIONAL_DETAILS,
//                 loanScopeDataHolder.getClientId(), payload)
//                 .then(professionalDetailsSaveRes => {
//                   if (professionalDetailsSaveRes.errorOccurred) {
//                     this.loading = false;
//                     this.networkError = professionalDetailsSaveRes.data;
//                     this.showErrorAlertDialog = true;
//                   } else {
//                     this.getNextTask()
//                   }
//                 })
//             } else {
//               const noOfEntries = professionalDetailsRes.data.length;
//               const rowId = professionalDetailsRes.data[noOfEntries - 1].id;
//               dataSource.updateDataTableEntryInMultiRowDataTable(DataTables.PROFESSIONAL_DETAILS,
//                 loanScopeDataHolder.getClientId(), rowId, payload)
//                 .then(professionalDetailsSaveRes => {
//                   if (professionalDetailsSaveRes.errorOccurred) {
//                     this.loading = false;
//                     this.networkError = professionalDetailsSaveRes.data;
//                     this.showErrorAlertDialog = true;
//                   } else {
//                     this.getNextTask()
//                   }
//                 })
//             }
//           }
//         })
//     },

//     getNextTask() {
//       loanTasksActivityNavigator.getNextTask(this.tasks)
//         .then(res => {
//           this.loading = false;
//           if (res.errorOccurred) {
//             this.networkError = res.data;
//             this.showErrorAlertDialog = true;
//           }
//         });
//     },
//   },

//   created: function () {
//     this.loading = true;
//     loanTasksUtility.getLoanStageConfigData(loanScopeDataHolder.getLoanId(),
//       loanScopeDataHolder.getCurrentLoanTask().name)
//       .then(stageConfigDataRes => {
//         this.loading = false;
//         if (stageConfigDataRes.errorOccurred) {
//           this.networkError = stageConfigDataRes.data;
//           this.showErrorAlertDialog = true;
//         } else {
//           this.professionOptions = stageConfigDataRes.data.properties[Constants.PROFESSION_OPTIONS];
//           this.showUI = true;
//         }
//       });
//   },

//   computed: {
//     dropdownConfig() {
//       return DefaultResourceConfig.DROP_DOWN;
//     },

//     redirectActivity() {
//       return Activities.LOAN_DETAILS;
//     },

//     tasks() {
//       return [Activities.PROFESSIONAL]
//     },

//     currentTaskName() {
//       if (loanScopeDataHolder.getCurrentLoanTask()
//         && loanScopeDataHolder.getCurrentLoanTask().name) {
//         return loanScopeDataHolder.getCurrentLoanTask().name
//       }
//       return '';
//     },

//     salaryLabel() {
//       if (EzUtils.areEqualString("BUSINESS", this.profession, true)) {
//         return 'Declared Income Per Month'
//       } else {
//         return 'In Hand Salary Per Month'
//       }
//     },

//     salaryLabelDes() {
//       return '(As reflecting in your bank statement)'
//     },

//     rupeeSign() {
//       return Constants.RUPEE
//     },
//   }
// }
</script>

  <!--  <style scoped src="../../../assets/style/base.css"></style>

<style scoped>
.btnStyleNext {
  margin: 50px auto 20px;
}
</style> -->